import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { Button, Message } from "../../../BP2Components";
import { useExcelExport } from "./useExcelExport";
import { Icon_Download } from "../../../BP2Components/Icons/icons";

interface ExcelExportButtonProps {
   listId?: number | string;
}

const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({ listId }) => {
   const intl = useIntl();
   const {
      isExporting,
      error,
      initiateExport,
      resetExport,
      isProcessing,
      isSuccess,
      isError,
      isSupported,
   } = useExcelExport();

   useEffect(() => {
      if (isProcessing) {
         Message.loading(intl.formatMessage({ id: "excelExport.processing" }), 0);
      } else if (isSuccess) {
         Message.destroy();
         Message.success(intl.formatMessage({ id: "excelExport.success" }));
         const timeoutId = setTimeout(() => {
            resetExport();
         }, 2000);
         return () => clearTimeout(timeoutId);
      } else if (isError) {
         Message.destroy();
         Message.error(intl.formatMessage({ id: "excelExport.failed" }));
      }
   }, [isProcessing, isSuccess, isError, error, resetExport, intl]);

   const handleExcelExport = async () => {
      if (!listId) {
         Message.error(intl.formatMessage({ id: "excelExport.noListId" }));
         return;
      }

      try {
         await initiateExport(listId);
      } catch (err) {
         console.error("Export error details:", err);
      }
   };

   return (
      isSupported && (
         <Button
            buttonType="link"
            disabled={isExporting || !listId}
            onClick={handleExcelExport}
            className="bp2-list-excel-export-button"
         >
            <Icon_Download fill={"none"} stroke={"currentColor"} />
            <span>
               {isExporting
                  ? intl.formatMessage({ id: "excelExport.exporting" })
                  : intl.formatMessage({ id: "excelExport.buttonText" })}
            </span>
         </Button>
      )
   );
};

export default ExcelExportButton;
